import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SafeArea } from '../components/ui/SafeArea';
import { DateToggle } from '../components/ui/DateToggle';
import { Spinner } from '../components/ui/Spinner';
import { BeaconGrid } from '../components/beacon/BeaconGrid';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { fetchFeed, setDateFilter } from '../store/slices/beaconsSlice';
import { getDateParam } from '../lib/formatters';
import { Radar, MapPin, ChevronDown } from 'lucide-react';
export function FeedPage() {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { feed, dateFilter, loading } = useAppSelector((s) => s.beacons);
    const { user } = useAppSelector((s) => s.auth);
    useEffect(() => {
        if (user?.cityId) {
            if (dateFilter === 'later') {
                const dayAfterTomorrow = new Date();
                dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 2);
                dispatch(fetchFeed({
                    from: dayAfterTomorrow.toISOString().split('T')[0],
                    cityId: user.cityId,
                }));
            }
            else {
                dispatch(fetchFeed({
                    date: getDateParam(dateFilter),
                    cityId: user.cityId,
                }));
            }
        }
    }, [dateFilter, user?.cityId]);
    const handleDateChange = (val) => {
        dispatch(setDateFilter(val));
    };
    return (_jsxs(SafeArea, { hasNav: true, children: [_jsxs("div", { className: "px-4 pt-4 pb-2", children: [_jsxs("div", { className: "flex items-center justify-between mb-2", children: [_jsx("h1", { className: "text-[20px] font-bold text-white", style: { fontFamily: "'Space Grotesk', sans-serif" }, children: "\u041C\u0430\u044F\u043A\u0438" }), _jsxs("button", { className: "flex items-center gap-1.5 active:opacity-70 transition-opacity", onClick: () => navigate('/city'), children: [_jsx(MapPin, { className: "w-3.5 h-3.5 text-white/50" }), _jsx("span", { className: "text-[13px] font-medium text-white/60", children: user?.city?.nameRu || 'Город' }), _jsx(ChevronDown, { className: "w-3 h-3 text-white/40" })] })] }), _jsx(DateToggle, { value: dateFilter, onChange: handleDateChange })] }), !user?.cityId ? (_jsxs("div", { className: "flex-1 flex flex-col items-center justify-center px-6", children: [_jsx(Radar, { className: "w-10 h-10 text-white/20 mb-4" }), _jsx("p", { className: "text-white/50 text-[14px] text-center", children: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0433\u043E\u0440\u043E\u0434, \u0447\u0442\u043E\u0431\u044B \u0443\u0432\u0438\u0434\u0435\u0442\u044C \u043C\u0430\u044F\u043A\u0438" })] })) : loading ? (_jsx("div", { className: "flex-1 flex items-center justify-center", children: _jsx(Spinner, {}) })) : (_jsx(BeaconGrid, { beacons: feed, showDate: dateFilter === 'later' }))] }));
}
